import { render } from "./VuePicture.vue?vue&type=template&id=a1249180&scoped=true"
import script from "./VuePicture.vue?vue&type=script&lang=js"
export * from "./VuePicture.vue?vue&type=script&lang=js"

import "./VuePicture.vue?vue&type=style&index=0&id=a1249180&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1249180"]])

export default __exports__